<template>
  <v-row>
    <v-col md="5" class="pb-0 hidden-sm-and-down">
      <v-img
        height="100vh"
        :src="registerDogImage"
        class="sticky-image"
      />
    </v-col>
    <lease-request-form-1
      v-if="this.currentPage === 1"
      :dogInfo="dogInfo"
      :changePage="changePage"
      :lesseeInfo="lessees"
      :changeLesseeInfo="changeLessees"
      :priceInfo="priceInfo"
      :primaryLessee="primaryLessee"
      :changePrimaryLessee="changePrimaryLessee"
    />
    <lease-request-form-2
      v-if="this.currentPage === 2"
      :changePage="changePage"
      :dates="dates"
      :changeDates="changeDates"
      :validationInfo="validationInfo"
    />
    <lease-request-form-3
      v-if="this.currentPage === 3"
      :changePage="changePage"
      :submitRequest="submitRequest"
      :validationInfo="validationInfo"
      :dogInfo="dogInfo"
      :lesseeInfo="lessees"
      :priceInfo="priceInfo"
      :signature="signature"
      :updateSignature="updateSignature"
        :status="status"
        :feesLoaded="feesLoaded"
    />
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";
import LeaseRequestForm1 from "./Steps/LeaseRequestForm1.vue";
import LeaseRequestForm2 from "./Steps/LeaseRequestForm2.vue";
import LeaseRequestForm3 from "./Steps/LeaseRequestForm3.vue";

import { UserInfo } from "@/types/User";
import AuthorizeNetResponseData from "@/types/AuthorizeNetResponseData";

import registerLeaseService from "@/services/portal/registerLeaseService";
import workflowService from "@/services/portal/workflowService";
import { isDateBefore } from "@/helpers/date-utils";

const registerDogImage = require('@/assets/register-dog.png');

export default Vue.extend({
  name: "LeaseRequest",
  data: function () {
    return {
      registerDogImage,
      dogInfo: {} as any,
      validationInfo: {} as any,
      currentPage: 1,
      lessees: [] as any[],
      primaryLessee: 0,
      dates: [] as Temporal.PlainDate[],
      priceInfo: { fullMemberPrice: 0, serviceMemberPrice: 0 },
      signature: "",
      status: {},
      feesLoaded: false,
    };
  },
  components: {
    LeaseRequestForm1,
    LeaseRequestForm2,
    LeaseRequestForm3,
  },
  methods: {
    changePage(page: number) {
      this.currentPage = page;
    },
    changeLessees(lessees: any[]) {
      if(lessees.length === 0){
        this.primaryLessee = 0;
      } else {
        if(this.primaryLessee === 0){
          this.primaryLessee = lessees[0].personId;
          lessees[0].isPrimary = true;
        }
      }
      this.lessees = lessees;
    },
    changePrimaryLessee(personId: number) {
      this.primaryLessee = personId;
      const index = this.lessees.map((c) => c.personId).indexOf(personId);
      this.lessees.forEach((co) => (co.isPrimary = false));
      this.lessees[index].isPrimary = true;
    },
    updateSignature(signature: string) {
      this.signature = signature;
    },
    changeDates(dates: Temporal.PlainDate[]) {
      if (isDateBefore(dates[1], dates[0])) {
        dates = dates.reverse();
      }
      this.dates = dates;
      this.$nextTick(() => {
        if (dates[1] && dates[0]) {
          registerLeaseService
            .validateLeaseDates(
              this.dogInfo.dogId,
              dates[0],
              dates[1]
            )
            .then((res) => {
              this.$data.validationInfo = res;
            })
            .catch((error) => {
              this.validationInfo = {};
              this.$handleError(error);
            });
        }
      });
    },
    submitRequest(paymentInfo: AuthorizeNetResponseData, signature: string) {
      const lessees = this.lessees;
      let req = {
        dogId: this.dogInfo.dogId,
        startDate: this.dates[0],
        endDate: this.dates[1],
        lesees: lessees,
        requesterSignatureText: signature,
        fee: this.validationInfo.fee,
        paymentInfo
      };
      registerLeaseService.submitLeaseRequest(req).then((res) => {
        this.status = res;
      }).catch((error) => {
        this.status = error;
      });
    },
  },
  created() {
    registerLeaseService.getLeasedDog(this.$props.dogId).then((res) => {
      this.$data.dogInfo = res;
    }).catch((error) => {
      this.dogInfo = {};
      this.$handleError(error);
    });
    workflowService.getRegisterLeaseFees().then((res) => {
      this.$data.priceInfo = res;
      this.feesLoaded = true;
    }).catch(this.$handleError);
  },
  props: {
    dogId: String,
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
</script>
